import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { lazy, useState } from 'react';

const PDFPageCounter = lazy(() => import('./PDFPageCounter'));
const WebpageCounter = lazy(() => import('./WebpageCounter'));

export default function AllApps() {
	const navigate = useNavigate();
	const params = useParams();
	const [value, setValue] = useState('pdf-counter');

	const handleChange = (event: React.SyntheticEvent, newValue: string) => {
		setValue(newValue);
		navigate(newValue);
	};

	return (
		<Box
			sx={{
				flexGrow: 1,
				bgcolor: 'background.paper',
				display: 'flex',
				height: '100vh',
			}}>
			<Box sx={{ borderBottom: 1, borderColor: 'divider' }}></Box>

			<Tabs orientation="vertical" value={value} variant="scrollable" onChange={handleChange} sx={{ borderRight: 1, borderColor: 'divider' }}>
				<Tab value={'pdf-counter'} label="PDF Page Counter" />
				<Tab value={'page-counter'} label="Website URL Counter" />
			</Tabs>

			<Box sx={{ width: '100%', p: 5 }}>
				<Routes>
					<Route path="/" element={<PDFPageCounter />} />
					<Route path="/pdf-counter" element={<PDFPageCounter />} />
					<Route path="/page-counter" element={<WebpageCounter />} />
				</Routes>
			</Box>
		</Box>
	);
}
